// 第1张
const imgAllA = {
    JP: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1723606710850/%E5%AE%B6%E5%BA%AD%E5%A4%87%E7%94%B5.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1723607105619/%E5%AE%B6%E5%BA%AD%E5%A4%87%E7%94%B5.jpg',
    },
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724660992760/v1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724660991687/d1.jpg',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725154457036/euPC1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725154630576/euH1.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725161235153/ukPC1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725161234812/ukH1.jpg',
    },
};
const imgLocale1: any = {
    jp: imgAllA.JP,
    us: imgAllA.NA,
    ca: imgAllA.NA,
    br: imgAllA.NA,
    mx: imgAllA.NA,
    uk: imgAllA.UK,
    eu: imgAllA.EU,
    de: imgAllA.EU,
    fr: imgAllA.EU,
    it: imgAllA.EU,
    es: imgAllA.EU,
};
export default imgLocale1;
